<template>
  <!-- 搜索-快讯列表页-->
  <div class="container">
    <!-- 文章列表 -->
    <div class="list" v-if="list.length != 0">
      <div v-for="(news, index) in list" :key="news.id">
        <!-- <V-OneNewsFlash :title="news.title" :list="list" :hotNum="news.hotNum" :time="news.time" :id="news.id" :lowerid="lowerid"></V-OneNewsFlash> -->
        <V-OneNewsFlash :title="news.title" :content="news.context" :time="formatDate(Date.parse(news.time))"
                :id="news.id" :item="news||{}" :hotNum="news.readNum" :hotlist="hotlist"></V-OneNewsFlash>
        <hr v-if="index + 1 != list.length" />
      </div>
    </div>
    <div v-if="list.length == 0" style="font-size: 20px;margin-top:100px; color:#626262">抱歉未找到相关结果</div>
    <br />
    <!-- 分页 -->
    <div class="page-nav">
      <el-pagination background layout="prev, pager, next" :total="totlePage" :page-size="pageSize" @current-change="currentPage"></el-pagination>
    </div>
  </div>
</template>

<script>
import OneNewsFlash from "@/components/one-news-flash/index.vue";
import { getArctilce,getHotArcticle  } from "@/services/";
import {  formatDate } from "@/js/common/index"
export default {
  data() {
    return {
      hidePageNav: true,
      pageNum: 0,
      pageSize: 12,
      totlePage: 0,
      list: [],
      lowerid: 0, //下一篇文章的ID
      hotlist:[],
      formatDate,
    };
  },
  created: function () {
    this.searchWord = this.$route.query.searchWord||''
    this.searchInfo();
    this.HotArcticle()
  },
  
  methods: {
    
    //当前页
    currentPage(e,val) {
      this.pageNum = e;
      this.searchInfo(val);
    },

    searchInfo(val) {
      let data = { type: 2, pageIndex:this.pageNum, pageSize:  this.pageSize }
      if(this.searchWord){
        data.title = this.searchWord
      }
      if(val){
        this.searchWord = val;
        data.title = val;
      }
      this.newarticlelist = [];
      getArctilce(data).then(res => {
        if (res.success) {
          let list = res.data.records
          this.totlePage = res.data.total || 0
          this.list = list;
        } else {
          this.message({
            message: res.message,
            type: 'warning'
          })
        }
      })
    },
    //快讯热榜
    HotArcticle(){
      getHotArcticle().then(res=>{
        if(res.success){
          this.hotlist = res.data.records||[];
        }
      })
    }
  },
  components: {
    "V-OneNewsFlash": OneNewsFlash
  }
};
</script>

<style scoped>
.container .list {
  width: 633px;
  display: inline-block;
  padding: 20px;
  background-color: #ffff;
}

.page-nav {
  display: inline-block;
  width: 800px;
  margin-top: 30px;
}
</style>